import Vue from "vue";
import App from "./app.vue";
import Router from "./modules/router.js";
import Store from "./modules/store.js";
import axios from "axios";
import VueAxios from "vue-axios";
import VueAnalytics from "vue-analytics";
import Firebase from "./modules/firebase";

Vue.use(VueAxios, axios);
Vue.use(VueAnalytics, {
    id: "UA-52651416-7",
    router: Router,
    debug: {
        sendHitTask: process.env.NODE_ENV === "production"
    }
});
Vue.use(Firebase, {
    apiKey: "AIzaSyDeYqutfo1ar1EPzcIwwgd5yU7-Nl3AEbc",
    authDomain: "gleebeam-app.firebaseapp.com",
    databaseURL: "https://gleebeam-app.firebaseio.com",
    projectId: "gleebeam-app",
    storageBucket: "gleebeam-app.appspot.com",
    messagingSenderId: "306093816280",
    appId: "1:306093816280:web:e851a37f7eac51da4d9aad",
    measurementId: "G-G6K5H5Y15N"
});

Vue.config.productionTip = false;

new Vue({
    router: Router,
    store: Store,
    render: h => h(App)
}).$mount("#app");
